import { Link, Typography } from '@mui/material';
import { ComponentProps, useContext } from 'react';

import { LinkButton } from '@/components/form/baseInputs/Link';

import { ContextualHelpId } from '../types';
import {
  ContextualHelpContext,
  ContextualHelpContextData,
} from './ContextualHelpContext';
import { HelpIconButton } from './HelpIconButton';

export interface ContextualHelpTriggerProps {
  display?: string;
  contextualHelpId: ContextualHelpId;
  variant?: 'default' | 'helpText';
  endIcon?: ComponentProps<typeof LinkButton>['endIcon'];
  contextData?: ContextualHelpContextData;
}

export function ContextualHelpTrigger({
  display,
  contextualHelpId,
  variant = 'default',
  endIcon,
  contextData,
}: ContextualHelpTriggerProps) {
  const contextualHelpCtx = useContext(ContextualHelpContext);
  if (!contextualHelpCtx) {
    throw new Error(
      'ContextualHelpDrawer must be used inside a ContextualHelpProvider.'
    );
  }

  const handleClick = () =>
    contextualHelpCtx.setContextualHelp(contextualHelpId, contextData);

  if (!display) {
    return (
      <HelpIconButton
        buttonProps={{
          onClick: (e) => {
            e.stopPropagation();
            handleClick();
          },
        }}
      />
    );
  }

  if (variant === 'helpText') {
    return (
      <Typography variant="body-xs">
        <Link
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
          sx={{ cursor: 'pointer' }}
        >
          {display}
        </Link>
      </Typography>
    );
  }

  return (
    <LinkButton display={display} onClick={handleClick} endIcon={endIcon} />
  );
}
